var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlockDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6855 8.28125H4.68555C4.27133 8.28125 3.93555 8.61704 3.93555 9.03125V19.5312C3.93555 19.9455 4.27133 20.2812 4.68555 20.2812H19.6855C20.0998 20.2812 20.4355 19.9455 20.4355 19.5312V9.03125C20.4355 8.61704 20.0998 8.28125 19.6855 8.28125Z",
    stroke: "#565556",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.81055 8.28125V4.90625C8.81055 4.01114 9.16613 3.1527 9.79906 2.51976C10.432 1.88683 11.2904 1.53125 12.1855 1.53125C13.0807 1.53125 13.9391 1.88683 14.572 2.51976C15.205 3.1527 15.5605 4.01114 15.5605 4.90625",
    stroke: "#565556",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockDark);
export default __webpack_public_path__ + "static/media/unlockDark.783e828b9c46c0e088a42a7eae5b0913.svg";
export { ForwardRef as ReactComponent };